<template>
  <div class="component-container">
    <div class="second-edition" id="second-edition">
      <h3>3LNG Second Edition: Life Cycles and Survival in an Ecosystem - Downloads and Resources</h3>
      
      <div class="back-button-wrapper">
        <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
      </div>
      <div class="presentations">
        <h4>Teacher Presentations</h4>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202024%20Updates%2F3LNG-2E_Activities_1-6_08212024.zip?alt=media&token=54c2273a-d7ed-401d-b8b0-15fb09d5458e" target="_blank">Teacher Presentations: Activities 1 - 6</a> - Updated 8/21/2024</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links Spreadsheet</a> - List of all links in the printed Teacher Guide</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=1062009112#gid=1062009112">Curriculum Updates Spreadsheet </a> - List with links to updates for your printed Teacher Guide</li>
        </ul>
      </div>
      <div class="presentations">
        <h4>Student Journals</h4>
        <p>Please make a master copy for your classroom and save to your Google drive for your classroom.</p>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1YgCDam63pmX5L42ScXvDYB-zt6lJhXHm5QEIh5zIEDw/copy" target="_blank">3LNG Second Edition: Life Cycles and Survival in an Ecosystem Student Journal</a></li>
          <li><a href="https://drive.google.com/file/d/1_TQcyzNpjnHriwYiMz0JEfWe4Q4iN8lw/view" target="_blank">3LNG Second Edition: Life Cycles and Survival in an Ecosystem Student Journal Answer Key</a></li>
          <!-- <li><span  style="color: #f47e20; margin-left: 40px; font-weight: 600;">Coming Soon! </span>3LNG Second Edition: Life Cycles and Survival in an Ecosystem Student Journal - SPANISH</li> -->
          <li><a href="https://docs.google.com/presentation/d/1LmoTu0iLU1txO-qqWVxXDHZPCpAuy0padtbsOz89eLE/copy" target="_blank">3LNG Life Cycles and Survival in an Ecosystem Student Journal - SPANISH</a></li>
        </ul>
      </div>
      <div class="presentations">
        <h4>Individual Resources</h4>
        <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make master copies and save in your Google drive for your classroom.</p>
        <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1kdKAdSatmwUpA88ShSwd0fJ8_IJQ4gYM7b85A7i5ryA/copy" target="_blank">What We Think Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/1ARs_J7uQhndX684TDaXHTk3TtPaHJuh9gIDJsRYCIZU/copy" target="_blank">Word Sort Cards - Lesson 1C</a></li>
          <li><a href="https://docs.google.com/presentation/d/1Ukp_BMAXYcUlvLkPQbiyVNr3d0bk7UOUN1Fylfna8-M/copy" target="_blank">Chart for Roleplay</a></li>
          <li><a href="https://docs.google.com/presentation/d/1BIbQ6NbmdvXWT1xReq4-cZeDWFJ3pdoHxU_gzGp6jaY/copy" target="_blank">Frog Pictures</a></li>
          <li><a href="https://docs.google.com/presentation/d/13IwGnPvVgYMSogeQLedBC174YseLVXGJHYvtVj5f-uA/copy" target="_blank">Habitat Pictures</a></li>
          <li><a href="https://docs.google.com/presentation/d/1qxcfuHBMYFJCL_BvTT33YdmL3inj7qz1asPPt4DCehg/copy" target="_blank">Word Sort Cards - Lesson 2A</a></li>
          <li><a href="https://docs.google.com/presentation/d/1Qs4IkFPB9sECqa8wWBniCCIhfjFqMxBBYhZXSAAKg7o/copy" target="_blank">Frogs in the Classroom - Lesson 2A</a></li>
          <li><a href="https://docs.google.com/presentation/d/17YfCXn7-H_I502rBqB6nyISq8dVcxvzeBHCya42RizI/copy" target="_blank">Tadpole Observation Log</a></li>
          <li><a href="https://docs.google.com/presentation/d/1i4l90Ykj4fQ-rd-hUelItKUS2vMAitHGleIZmGqdT-0/copy" target="_blank">Habitat, Plant, and Animal Cards</a></li>
          <li><a href="https://docs.google.com/presentation/d/1bfkR7pr-0e3YpJ9XLNthHO7w_DmtOmI_10BYi6NZ_mE/copy" target="_blank">Word Sort Cards - Lesson 2B</a></li>
          <li><a href="https://docs.google.com/presentation/d/1g_hGk0_zHk_FfMUa8X1VT7rux4OkV00HRJwdsyZidzQ/copy" target="_blank">Word Sort Cards Lesson 2E</a></li>
          <li><a href="https://docs.google.com/presentation/d/1V2K50gtsobtDoLmUx-kqDX0vS3lGEvSutrVhVxlF_-8/copy" target="_blank">Life Cycle Model Product Descriptor</a></li>
          <li><a href="https://docs.google.com/presentation/d/1KYDbpJ7cHUSHSPByHB-TMhFnrSarKelCgyIaWj28BXU/copy" target="_blank">Word Sort Cards - Lesson 3D</a></li>
          <li><a href="https://docs.google.com/presentation/d/1jj1d6ejrTHlGOZe6IIY6UrJYHWeb6SdYMEorvICfhwE/copy" target="_blank">My Inherited Traits Handout</a></li>
          <li><a href="https://docs.google.com/presentation/d/1sNP3MDTPOIfjRzRPlrsHK2G29CQ3NJbbv2szmwq4vg0/copy" target="_blank">Science Journal Product Descriptor</a></li>
          <!-- <li><a href="" target="_blank"></a></li> -->

        </ul>
      </div>
    </div>
  </div>
  </template>

  <script>
  import { mapState } from 'vuex'

  export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
  }
  </script>

  <style lang="css" scoped>
  .presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
  }
  ul {
  list-style: none;
  }
  .presentations a {
  margin-left: 40px;
  }
  li {
  margin-left: -40px;
  }
  .back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
  }
  .back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
  }
  </style>
